import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  keyId: string;
};

export const regenerateApiKeySecret = async (
  scope: RequestScope,
  { keyId }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<{ value: string }>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<{ value: string }>>(`/organization/client_regenerate/${keyId}`, undefined, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
